import React from "react";
import {useTranslation} from "react-i18next";

import {API_ENDPOINTS, BASE_PATH} from "../../api/endpoints";
import {COLOR_SCHEME} from "../../utilities/colorSheme";
import PageContainer from "../conteiners/PageContainer";
import ErrorBoundary from "../errorBoundary/ErrorBoundary";
import {PF_CONTROL_TABLE_COLUMNS} from "../KP/kp/KpPfControl/utils/constants";
import {KP_LIST_TABLE_COLUMNS} from "../KP/KpSecondVersion/constants";
import {PROJECT_TABLE_COLUMNS} from "../Project/ProjectSecondVersion/constants";
import {
  LOGIST_REQ_TABLE_WITH_SP,
  MANAGER_CO_INCOMING_REQ_TABLE,
  REQUEST_TABLE_COLUMNS,
} from "../Requests/RequestRegister/RequestTable/utils/constants";

import MainPageSection from "./MainPageSection";
import RemindsList from "./RemindsList";
import useMainPageSections from "./useMainPageSections";

import "./MainPage.scss";

const MainPage = () => {
  const {t} = useTranslation();

  const {
    projectsTableData,
    areProjectsShown,
    areProjectsLoading,
    controlPfTableData,
    areControlPfShown,
    isControlPfLoading,
    incomingReqTableData,
    areIncomingRequestsShown,
    areIncomingRequestsLoading,
    feaReqInProgressTableData,
    areFeaReqInProgressShown,
    isFeaReqInProgressLoading,
    onFeaReqInProgressPaginate,
    feaReqInProgressPage,
    feaReadyStatusReqTableData,
    areFeaReadyStatusReqShown,
    areReadyStatusReqLoading,
    onReadyStatusReqPaginate,
    feaReadyStatusReqPage,
    reqForDistributionLogTableData,
    areReqForDistributionLogShown,
    areReqForDistributionLogLoading,
    areActiveCOsShown,
    areActiveCOsLoading,
    activeCOsTableData,
    onActiveCOsPaginate,
    activeCOsPage,
  } = useMainPageSections();

  const sections = [
    {
      columnsConst: PROJECT_TABLE_COLUMNS,
      data: projectsTableData,
      title: "Active projects ",
      linkTo: `/${BASE_PATH}/${API_ENDPOINTS.PROJECT.BASE}`,
      hidden: !areProjectsShown,
      loading: areProjectsLoading,
    },
    {
      columnsConst: KP_LIST_TABLE_COLUMNS,
      data: activeCOsTableData,
      title: "Active COs",
      linkTo: `/${BASE_PATH}/${API_ENDPOINTS.CO.BASE}`,
      hidden: !areActiveCOsShown,
      loading: areActiveCOsLoading,
      paginatable: true,
      onPaginate: onActiveCOsPaginate,
      page: activeCOsPage,
    },
    {
      columnsConst: PF_CONTROL_TABLE_COLUMNS,
      data: controlPfTableData,
      title: "Control PF",
      linkTo: `/${BASE_PATH}/${API_ENDPOINTS.CO.BASE}/${API_ENDPOINTS.CO.CONTROL}`,
      hidden: !areControlPfShown,
      loading: isControlPfLoading,
    },
    {
      columnsConst: MANAGER_CO_INCOMING_REQ_TABLE,
      data: incomingReqTableData,
      title: "Incoming requests",
      linkTo: `/${BASE_PATH}/${API_ENDPOINTS.VED.BASE}/${API_ENDPOINTS.VED.BOSS_REQUEST_REGISTER}`,
      hidden: !areIncomingRequestsShown,
      loading: areIncomingRequestsLoading,
    },
    {
      columnsConst: REQUEST_TABLE_COLUMNS,
      data: feaReqInProgressTableData,
      title: "Requests in progress FEA",
      linkTo: `/${BASE_PATH}/${API_ENDPOINTS.VED.BASE}/${API_ENDPOINTS.VED.REQUESTS_IN_PROGRESS}`,
      hidden: !areFeaReqInProgressShown,
      loading: isFeaReqInProgressLoading,
      paginatable: true,
      onPaginate: onFeaReqInProgressPaginate,
      page: feaReqInProgressPage,
    },
    {
      columnsConst: REQUEST_TABLE_COLUMNS,
      data: feaReadyStatusReqTableData,
      title: "Ready status requests FEA",
      linkTo: `/${BASE_PATH}/${API_ENDPOINTS.VED.BASE}/${API_ENDPOINTS.VED.READY_STATUS_REQUESTS}`,
      hidden: !areFeaReadyStatusReqShown,
      loading: areReadyStatusReqLoading,
      paginatable: true,
      onPaginate: onReadyStatusReqPaginate,
      page: feaReadyStatusReqPage,
    },
    {
      columnsConst: LOGIST_REQ_TABLE_WITH_SP,
      data: reqForDistributionLogTableData,
      title: "Requests for distribution Logist",
      linkTo: `/${BASE_PATH}/${API_ENDPOINTS.LOGIST.BASE}/${API_ENDPOINTS.LOGIST.REQUESTS_REGISTER_BOSS}`,
      hidden: !areReqForDistributionLogShown,
      loading: areReqForDistributionLogLoading,
    },
  ];

  const visibleSections = sections.filter(section => !section.hidden) || [];

  return (
    <ErrorBoundary>
      <PageContainer title={``} loading={false}>
        <div className="form_wrapper gap">
          <div className="row jcsb w100 aistr" style={{height: "400px"}}>
            <ul className="fcCol gap aistr">
              {visibleSections.map(({linkTo, title}) => (
                <li key={title}>
                  <a href={`#${linkTo}`} style={{color: COLOR_SCHEME.LINK}}>
                    {t(title)}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mainToDo" style={{}}>
              <label className="label">TODO:</label>
              <div className="mainToDo__container">
                <RemindsList />
              </div>
            </div>
          </div>
          {/* <div className={clsx("activeProjects", !areControlPfShown && "hidden")} style={{height: "90%"}}>
            <label className="label">{t("Active projects")}</label>
            <div className="activeProjects__container" style={{height: "30rem"}}>
              <ActivesList />
            </div>
          </div> */}
          {visibleSections.map((props, index) => (
            <MainPageSection key={index + props.title} {...props} />
          ))}
        </div>
      </PageContainer>
    </ErrorBoundary>
  );
};

export default MainPage;
